import React, { FC } from "react";
import { TextField } from "@mui/material";
import { Control, Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { CreateUpdateEntityFormValues } from "../../EntityEditor";

interface Currency {
  control: Control<CreateUpdateEntityFormValues>;
}

const Currency: FC<Currency> = ({ control }) => {
  const { t } = useTranslation();

  return (
    <Controller
      control={control}
      name="revenueAndExpenses"
      render={({
        field: { onBlur, onChange, name, value },
        fieldState: { error },
      }): React.ReactElement => (
        <TextField
          {...{ onBlur, onChange, name, value }}
          fullWidth
          type="text"
          label={t("entitiesManagement.entityEditor.revenueAndExpenses")}
          helperText={error?.message}
          error={Boolean(error)}
        />
      )}
    />
  );
};

export default Currency;
